// extracted by mini-css-extract-plugin
module.exports = {"container":"Vf-z","heading":"Wf-z","links":"Xf-z","linkBtn":"Yf-z","disabled":"Zf-z","linkUppercaseBold":"_f-z","copy":"ag-z","subCopy":"bg-z"};